{getIdsAsList} = require('../../utils')

module.exports = {

  countries: (Api) ->
    return Api.Country.query().$promise

  states: (Api) ->
    return Api.State.query().$promise

  managedUsers: (Api) ->
    return Api.SimpleManagedUser.query({is_active: true}).$promise

  processes: (Api) ->
    return Api.Processes.query().$promise

  user: (User) ->
    return User.resolve()

  workflowTemplatesLoad: (Api) ->
    return Api.WorkflowTemplate.query().$promise

  workflowTemplates: (template, workflowTemplatesLoad, user) ->
    return template.filterWorkflowTemplatesByClientGroup(workflowTemplatesLoad, user.client_groups)

  adverseTermsLists: (Api) ->
    return Api.AdverseTerms.query().$promise

}
